import type { ApiResponse } from "@/types";

import { BaseApi } from "../base.api";

export const STUDENT_NOTE_KINDS = ["NOTE", "CALL", "MEETING", "WARNING"] as const;
export type StudentNoteKind = (typeof STUDENT_NOTE_KINDS)[number];

/** Talaba haqidagi ichki qayd — backend'dagi `StudentNoteDto`. Talabaga ko'rinmaydi. */
export interface StudentNote {
  id: number;
  studentId: number;
  courseId: number | null;
  courseTitle: string | null;
  kind: StudentNoteKind;
  body: string;
  author: { id: number; firstName: string; lastName: string; role: string };
  /** Joriy foydalanuvchi tahrirlay/o'chira oladimi. */
  canEdit: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateStudentNoteData {
  studentId: number;
  courseId?: number;
  kind?: StudentNoteKind;
  body: string;
}

/** Talaba haqidagi qaydlar API si — backend'dagi `StudentNotesController`. */
export class StudentNotesApi extends BaseApi {
  private readonly baseUrl: string = "/student-notes";

  list(studentId: number, courseId?: number) {
    return this.request.get<StudentNote[], ApiResponse<StudentNote[]>>(this.baseUrl, {
      params: { studentId, courseId },
    });
  }

  create(data: CreateStudentNoteData) {
    return this.request.post<StudentNote, ApiResponse<StudentNote>>(this.baseUrl, data);
  }

  update(id: number, data: { kind?: StudentNoteKind; body?: string }) {
    return this.request.patch<StudentNote, ApiResponse<StudentNote>>(`${this.baseUrl}/${id}`, data);
  }

  remove(id: number) {
    return this.request.delete<null, ApiResponse<null>>(`${this.baseUrl}/${id}`);
  }
}

export const studentNotesApi = new StudentNotesApi();
